// components
import { Helmet } from "react-helmet";

const Title = ({ title }) => {
  return (
    <Helmet>
      <title>{title} | Probal</title>
    </Helmet>
  );
};

export default Title;
